import React from 'react';
import Typewriter from 'typewriter-effect';
import { useTranslation } from 'react-i18next';
const Hero = () => {
    const [t, i18n] = useTranslation("global");
    return (
        <div className="min-h-screen font-kanit w-full flex flex-col items-center justify-center text-white px-4 md:px-0 text-center">
            <h1 className="font-messina tracking-wide  mb-2 text-4xl md:text-5xl lg:text-6xl xl:text-7xl">
                Resguar IT
            </h1>
            <div className="font-neolatina text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-2xl mx-auto">
                <Typewriter 
                    options={{
                        strings: [t("hero.slogan1"), t("hero.slogan2")],
                        autoStart: true,
                        loop: true,
                        delay: 50,
                    }}
                />
                
            </div>
        </div>
    );
};

export default Hero;
